export const columnsRfid = [
  {
    accessor: 'rfidNumber',
    contentType: 'text',
    headerType: 'text',
    position: 'left'
  },
  {
    accessor: 'userId',
    headerType: 'text',
    contentType: 'text',
    position: 'left'
  },
  {
    accessor: 'status',
    headerType: 'text',
    contentType: 'status',
    position: 'center'
  },
  {
    accessor: 'idTag',
    headerType: 'text',
    contentType: 'status',
    position: 'center'
  },
  {
    accessor: 'lastUsage',
    contentType: 'text',
    headerType: 'text',
    position: 'left'
  }
];
